// Spotify Ads Manager pixel events (base pixel installed in public/index.html)
export const spotifyTrack = (event, params) => {
  if (typeof window !== "undefined" && typeof window.spdt === "function") {
    window.spdt(event, params);
  }
};

export const gaPageview = (path) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  }
};

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

export const captureUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 100);
  });
  if (Object.keys(found).length) {
    sessionStorage.setItem("freshly_utm", JSON.stringify(found));
  }
};

export const getUtm = () => {
  try {
    return JSON.parse(sessionStorage.getItem("freshly_utm")) || {};
  } catch {
    return {};
  }
};

